// extracted by mini-css-extract-plugin
export default {"date-range-text__dates":"DatePicker_date-range-text__dates__Kgbo4"};